import { StoredMediaFilesSchema } from "@repo/types";
import type { Doc } from "@types_def/models/delivery.types";

/** Validate persisted document JSON before exposing it to editable forms. */
export function parseDocs(value: unknown): Doc[] {
  if (value == null) return [];
  const parsed: unknown = typeof value === "string" ? JSON.parse(value) : value;
  return StoredMediaFilesSchema.parse(parsed);
}
